<div class="d-flex flex-row">
  <div [ngbTooltip]="tooltip">
    <button type="button" class="btn btn-sm btn-light" [disabled]="disabled || protect" (click)="toggle(!all, false)" container="body">
      <fa-icon *ngIf="all" [icon]="['fal', 'check']" [fixedWidth]="true"></fa-icon>
      <fa-icon *ngIf="!all" [icon]="['fal', 'times']" class="inactive" [fixedWidth]="true"></fa-icon>
    </button>
  </div>

  <div *ngIf="recursive" [ngbTooltip]="tooltipChildren">
    <button
      type="button"
      class="btn btn-sm btn-light"
      [disabled]="disabled || protect || !children"
      (click)="toggle(!all, true)"
      container="body"
    >
      <fa-icon *ngIf="all" [icon]="['fal', 'layer-plus']" [fixedWidth]="true"></fa-icon>
      <fa-icon *ngIf="!all" [icon]="['fal', 'layer-minus']" class="inactive" [fixedWidth]="true"></fa-icon>
    </button>
  </div>

  <ng-container *ngIf="all === any; else conflict">
    <ng-container *ngIf="children && (childrenAll !== all || childrenAny !== any); then incomplete"> </ng-container>
  </ng-container>
</div>

<ng-template #conflict>
  <div class="mt-1 ms-1" ngbTooltip="Conflicting roles selected" container="body">
    <fa-icon [icon]="['fal', 'exclamation-triangle']" [fixedWidth]="true"></fa-icon>
  </div>
</ng-template>

<ng-template #incomplete>
  <div class="mt-1 ms-1" ngbTooltip="Some child nodes do not share this setting" container="body">
    <fa-icon [icon]="['fal', 'exclamation-circle']" [fixedWidth]="true"></fa-icon>
  </div>
</ng-template>
